/* Uitverkocht-blok op de productpagina — zie snippets/hop-uitverkocht.liquid */
(function () {
  // Het thema rendert de productkop twee keer (mobiel + desktop): elk blok apart opzetten
  var CACHE = {};
  function haal(url) {
    if (!CACHE[url]) CACHE[url] = fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return CACHE[url];
  }
  var FEED;
  // Mobiel: onder de productfoto (14 okt 2026). In de prijsrij liep het blok uit het scherm.
  // Desktop blijft ongemoeid (rechterkolom bij de prijs). Het thema rendert de kop twee keer;
  // alleen de zichtbare mobiele kopie verhuist naar direct onder de mobiele foto.
  var mobielFoto = document.querySelector(".product__primary-left > .product__media-container.below-mobile");
  if (mobielFoto && mobielFoto.offsetParent !== null) {
    var zichtbaar = Array.prototype.filter.call(document.querySelectorAll("[data-hop-uv]"), function (b) { return b.offsetParent !== null; })[0];
    if (zichtbaar) {
      zichtbaar.classList.add("hop-uv--onder-foto");
      mobielFoto.insertAdjacentElement("afterend", zichtbaar);
    }
  }
  document.querySelectorAll("[data-hop-uv]").forEach(function (el) {
    if (el.dataset.klaar) return;
    el.dataset.klaar = "1";
    init(el);
  });

  function init(el) {

  var I = {};
  try { I = JSON.parse(el.querySelector("[data-hop-uv-i18n]").textContent); } catch (e) {}
  var ROOT = (el.dataset.root || "/").replace(/\/$/, "");
  var KLAVIYO = "https://a.klaviyo.com/client/";
  var HDR = { "Content-Type": "application/vnd.api+json", revision: "2025-07-15" };

  // ---------- seintje bij terugkomst ----------
  var form = el.querySelector(".hop-uv__form");
  var status = el.querySelector(".hop-uv__status");
  form.addEventListener("submit", function (ev) {
    ev.preventDefault();
    var adres = form.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(adres)) { status.textContent = I.ongeldig || ""; form.email.focus(); return; }
    var knop = form.querySelector("button");
    knop.disabled = true;
    status.textContent = "";
    var event = fetch(KLAVIYO + "events?company_id=V6BeY6", {
      method: "POST",
      headers: HDR,
      body: JSON.stringify({ data: { type: "event", attributes: {
        metric: { data: { type: "metric", attributes: { name: "Seintje Terug Op Voorraad" } } },
        profile: { data: { type: "profile", attributes: { email: adres } } },
        properties: {
          ProductId: el.dataset.productId,
          Handle: el.dataset.handle,
          Titel: el.dataset.titel,
          Taal: el.dataset.taal || "nl",
        },
      } } }),
    }).then(function (r) { if (!r.ok) throw new Error("klaviyo " + r.status); });
    var abonnement = !form.nieuwsbrief.checked ? Promise.resolve() : fetch(KLAVIYO + "subscriptions?company_id=V6BeY6", {
      method: "POST",
      headers: HDR,
      body: JSON.stringify({ data: { type: "subscription", attributes: {
        custom_source: "Seintje uitverkocht bier",
        profile: { data: { type: "profile", attributes: { email: adres } } },
      }, relationships: { list: { data: { type: "list", id: "Vp7gd9" } } } } }),
    }).catch(function () {});
    Promise.all([event, abonnement]).then(function () {
      form.querySelector(".hop-uv__rij").hidden = true;
      form.querySelector(".hop-uv__vink").hidden = true;
      status.textContent = I.bedankt || "";
      try { if (window.klaviyo && typeof window.klaviyo.identify === "function") window.klaviyo.identify({ email: adres }); } catch (e) {}
    }).catch(function () {
      knop.disabled = false;
      status.textContent = I.mislukt || "";
    });
  });

  // ---------- vergelijkbare bieren ----------
  var feed = FEED;
  if (!feed) {
    try { feed = FEED = JSON.parse(el.querySelector("[data-hop-uv-feed]").textContent); } catch (e) { return; }
  }
  if (!feed || !feed.b || !feed.st) return;
  var stijlIdx = -1, profiel = null;
  feed.st.forEach(function (s, i) { if (s[0] === el.dataset.stijl) { stijlIdx = i; profiel = s[2]; } });
  var abv = Number(el.dataset.abv) || 0;
  var prijs = Number(el.dataset.prijs) || 0;
  var kandidaten = feed.b.filter(function (b) { return b[0] !== el.dataset.handle && b[6] > 0; }).map(function (b) {
    var zelfdeStijl = b[1] === stijlIdx;
    var zelfdeProfiel = profiel && feed.st[b[1]] && feed.st[b[1]][2] === profiel;
    var score = (zelfdeStijl ? 0 : zelfdeProfiel ? 20 : 100) + (abv && b[2] > 0 ? Math.abs(b[2] - abv) / 5 : 4) +
      (prijs && b[5] > 0 ? Math.abs(Math.log(b[5] / prijs)) * 8 : 3) - (b[9] || 0) / 100;
    return { h: b[0], score: score };
  });
  if (stijlIdx < 0 && !profiel) return; // zonder stijl is "vergelijkbaar" gokken
  kandidaten.sort(function (a, b) { return a.score - b.score; });

  function euro(cent) {
    return (cent / 100).toFixed(2).replace(".", ","); // zonder €-teken (17 okt 2026)
  }
  function kaart(p) {
    var v = null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) { v = p.variants[i]; break; }
    if (!v || !p.featured_image) return null;
    var li = document.createElement("li");
    var a = document.createElement("a");
    a.href = ROOT + "/products/" + p.handle;
    var img = document.createElement("img");
    img.src = p.featured_image + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=240";
    img.alt = p.title;
    img.loading = "lazy";
    img.width = 120;
    img.height = 120;
    var t = document.createElement("span");
    t.className = "hop-uv__naam";
    t.textContent = p.title;
    var pr = document.createElement("span");
    pr.className = "hop-uv__prijs";
    pr.textContent = euro(v.price);
    a.appendChild(img); a.appendChild(t); a.appendChild(pr);
    li.appendChild(a);
    return li;
  }
  var lijst = el.querySelector(".hop-uv__lijst");
  var gevuld = 0, i = 0;
  function volgende() {
    if (gevuld >= 4 || i >= kandidaten.length || i >= 12) {
      if (gevuld) el.querySelector(".hop-uv__alt").hidden = false;
      return;
    }
    var h = kandidaten[i++].h;
    haal(ROOT + "/products/" + encodeURIComponent(h) + ".js")
      .then(function (p) {
        var li = p && kaart(p);
        if (li) { lijst.appendChild(li); gevuld++; }
        volgende();
      });
  }
  volgende();
  }
})();
